import * as Sentry from '@sentry/react'
import { ReactNode } from 'react'

interface FallbackProps {
  error: Error
  resetError: () => void
}

function ErrorFallback({ error, resetError }: FallbackProps) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Something went wrong</h2>
      <pre style={{ color: '#ef5343', margin: '1rem 0' }}>{error.message}</pre>
      <button
        onClick={resetError}
        style={{
          padding: '0.5rem 1rem',
          borderRadius: '8px',
          border: '1px solid #ccc',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </div>
  )
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
